import type { SubCategoryInfo } from '@features/category-navigation';
import './SubCategoryTabs.css';

interface SubCategoryTabsProps {
  subCategories: SubCategoryInfo[];
  selectedSubCategory: string | null;
  onSubCategoryChange: (slug: string) => void;
  showContrastButton?: boolean;
  onContrastClick?: () => void;
  isContrastActive?: boolean;
}

export function SubCategoryTabs({
  subCategories,
  selectedSubCategory,
  onSubCategoryChange,
  showContrastButton = false,
  onContrastClick,
  isContrastActive = false,
}: SubCategoryTabsProps) {
  if (subCategories.length === 0) {
    return null;
  }

  const sorted = [...subCategories].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <div className="subcategory-tabs">
      <div className="subcategory-tabs__perspectives">
        <div className="subcategory-tabs__buttons" role="tablist">
          {sorted.map((sub) => {
            const isActive = selectedSubCategory === sub.slug && !isContrastActive;

            return (
              <button
                key={sub.slug}
                className={`subcategory-tabs__tab subcategory-tabs__tab--${sub.slug} ${isActive ? 'subcategory-tabs__tab--active' : ''}`}
                onClick={() => onSubCategoryChange(sub.slug)}
                role="tab"
                aria-selected={isActive}
              >
                <span className="subcategory-tabs__tab-name">{sub.name}</span>
                <span className="subcategory-tabs__tab-full">{sub.name}</span>
              </button>
            );
          })}
          {showContrastButton && onContrastClick && (
            <button
              className={`subcategory-tabs__tab subcategory-tabs__tab--compare ${isContrastActive ? 'subcategory-tabs__tab--active' : ''}`}
              onClick={onContrastClick}
              role="tab"
              aria-selected={isContrastActive}
            >
              <span className="subcategory-tabs__tab-name">Compare</span>
              <span className="subcategory-tabs__tab-full">Compare</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
